import styled from 'styled-components';
import BaseStopStationIcon from '#/shared/components/GeneratedIcons/trimet/StopStationSolid';
import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import { ClearButton } from '#/shared/components/Styled';
import GTM_HANDLES from '#/shared/gtm-handles';

export const StopListBody = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 8px;
  overflow-y: auto;
`;

export const BasicStopRow = styled(ClearButton).attrs({
  role: 'link',
  [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.route.stopDetailButton,
})`
  display: flex;
  flex-direction: row;
  margin: 3px 0;
  padding: 5px;
  user-select: none;
  background-color: ${props => props.theme.secondaryBackgroundColor};
  border: 1px solid ${props => props.theme.tertiaryColor};
  border-radius: 5px;
  align-items: center;
  transition: ${props => props.theme.boxShadowTransition};
  @media (any-hover: hover) {
    &:hover {
      transition: ${props => props.theme.boxShadowTransition};
      box-shadow: ${props => props.theme.boxShadowCardHover};
      background-color: ${props => props.theme.secondaryBackgroundColor};
    }
  }
  &:focus,
  &:active {
    background-color: ${props => props.theme.secondaryBackgroundColor};
  }
`;

export const StopIconColumn = styled.div`
  flex: 0 0 auto;
  margin: 3px;
  display: flex;
`;

export const StopIcon = styled(BaseStopStationIcon).attrs(props => ({
  fill: props.theme.primaryFontColor,
  width: 25,
  height: 25,
}))``;

export const StopDescriptionColumn = styled.div`
  font-size: 1.2em;
  margin-left: 10px;
`;
